<template>
  <div>
    <head-bar title="Grootte toevoegen">
      <template v-slot:left>
        <head-bar-link @click="onBackClick">
          <img src="../../assets/arrow-left.svg" alt="" aria-hidden="true" />
          <span class="visually-hidden">Terug</span>
        </head-bar-link>
      </template>
    </head-bar>

    <app-layout classes="pet-height">
      <form class="p-2 p-md-3" action="" @submit.prevent="onSubmit">
        <Errors :errors="serverErrors" />

        <div class="mb-2">
          <label class="mb-1 d-block" for="date">
            Datum
          </label>
          <input
            class="form-control"
            type="date"
            id="date"
            v-model="form.date"
            :max="dateMax"
          >
        </div>

        <div class="mb-2">
          <label class="mb-1 d-block" for="height_in_centimeters">
            Grootte (centimeters)
          </label>
          <input
            class="form-control"
            type="number"
            id="height_in_centimeters"
            v-model="form.height_in_centimeters"
            min="0"
            max="200"
          >
        </div>

        <div class="d-flex">
          <button
            class="btn btn--primary"
            type="submit"
            :disabled="petHeightLoadingState === 'loading'"
          >
            {{
              petHeightLoadingState === 'loading'
                ? 'Een moment geduld...'
                : 'Grootte opslaan'
            }}
          </button>

          <button
            class="btn ml-auto"
            type="button"
            v-if="form.pet_height_id"
            @click="onDeletePetHeight"
          >
            Verwijderen
          </button>
        </div>
      </form>
    </app-layout>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns';
import { mapGetters } from 'vuex';
import { useToast } from 'vue-toastification';
import HeadBar from '../../components/HeadBar.vue';
import HeadBarLink from '../../components/HeadBarLink.vue';
import Errors from '../../components/Errors.vue';
import AppLayout from '../AppLayout.vue';
import retrieveErrorsFromResponse from '../../helpers/retrieveErrorsFromResponse';

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },

  components: {
    Errors,
    AppLayout,
    HeadBarLink,
    HeadBar,
  },

  data() {
    return {
      dateMax: format(new Date(), 'yyyy-MM-dd'),
      serverErrors: [],
      form: {
        pet_height_id: null,
        date: format(new Date(), 'yyyy-MM-dd'),
        height_in_centimeters: 20,
      },
    };
  },

  computed: {
    ...mapGetters([
      'petHeightLoadingState',
    ]),
  },

  mounted() {
    const id = this.$route.params?.id;

    if (typeof id !== 'undefined') {
      // Empty the form to give the user some indication that we're loading the
      // new data.
      this.form.date = '';
      this.form.height_in_centimeters = '';
      this.form.pet_height_id = id;

      this.getPetHeight(id);
    }
  },

  methods: {
    onBackClick() {
      this.$router.go(-1);
    },

    onSubmit() {
      this.$store.dispatch('storePetHeight', this.form)
        .then(({ data }) => {
          this.form.pet_height_id = data.id;

          this.toast.success('Grootte opgeslagen');
          this.$router.push({ name: 'PetHeightDetail', params: { id: data.id } });
        })
        .catch((err) => {
          this.serverErrors = !err.response
            ? ['Er ging iets mis. Probeer het later opnieuw.']
            : retrieveErrorsFromResponse(err.response);
        });
    },

    onDeletePetHeight() {
      if (!this.form.pet_height_id) {
        return;
      }

      // eslint-disable-next-line no-alert
      if (!window.confirm('Weet je het zeker?')) {
        return;
      }

      this.$store.dispatch('destroyPetHeight', this.form.pet_height_id)
        .then(() => {
          this.toast.success('Grootte is verwijderd');
          this.$router.push({ name: 'Feed' });
        })
        .catch(() => {
          this.serverErrors = ['Er ging iets mis, probeer het later opnieuw'];
        });
    },

    getPetHeight(id) {
      this.$store.dispatch('getPetHeight', id)
        .then(({ data }) => {
          this.form.height_in_centimeters = data.centimeters;
          this.form.date = format(parseISO(data.created_at), 'yyyy-MM-dd');
        });
    },
  },
};
</script>

<style scoped>
.pet-height {
  padding-top: 3.5rem;
}
</style>
